export default __webpack_public_path__ + "ee8bfa456b458c25a3ace2b610af4388.svg";